import styled from 'styled-components/macro';
import tw from 'tailwind.macro';

const FaqText = styled.p`
  ${tw`px-def mb-abs1 text-justify`};
`;

export default FaqText;
